import { useEffect } from 'react';
import { isNotNil } from '~/utilities/type-guards';
import { useSpellboundInfoQueryQuery } from './__gql/useSpellboundInfoQuery.gql.gen';

declare global {
  interface Window {
    spellboundInfo?: {
      spellboundDeployment: {
        name?: string;
        source?: string;
        gitSha?: string;
        deployedAt?: string;
      };
      domSource: string | null;
    };
  }
}

export const useSpellboundInfo = (bundleName: string): void => {
  const { data, error } = useSpellboundInfoQueryQuery({
    variables: { bundleName },
  });

  useEffect(() => {
    if (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      return;
    }

    if (isNotNil(data)) {
      const { name, source, gitSha, deployedAt } = data.appMetadata.spellboundDeployment ?? {};
      // Find the script tag in the DOM to verify it matches
      const scriptTag = document.querySelector(`script[src*="${bundleName}"]`);
      const scriptTagSrc = scriptTag?.getAttribute('src') ?? null;
      let domSource = '';
      if (isNotNil(scriptTagSrc)) {
        try {
          const path = new URL(`http:${scriptTagSrc}`).pathname;
          domSource = `/${path.split('/').slice(2).join('/')}`; // Remove the first part of the path to get a path that matches the server source
        } catch {
          domSource = scriptTagSrc; // If we can't parse the URL, use the raw value
        }
      }

      window.spellboundInfo = {
        spellboundDeployment: {
          name,
          source,
          gitSha,
          deployedAt,
        },
        domSource,
      };
    }
  }, [data, bundleName, error]);
};
